interface IPatternData {
  0: string[];
  1: string[];
}

class PathPattern {
  hidePattern: string[];
  sharePattern: string[];
  isShare: boolean;
  constructor(data: IPatternData) {
    [this.hidePattern, this.sharePattern] = PathPattern.initialize(data);
    this.isShare = true;
  }
  private static initialize(data: IPatternData): string[][] {
    let hidePathPattern = [""];
    let sharePathPattern = [""];
    if (data) {
      if (data[0]) {
        hidePathPattern = [...data[0]];
        hidePathPattern.push("");
      }
      if (data[1]) {
        sharePathPattern = [...data[1]];
        sharePathPattern.push("");
      }
    }
    return [hidePathPattern, sharePathPattern];
  }
  get current(): string[] {
    return this.isShare ? this.sharePattern : this.hidePattern;
  }
  addPattern(index: number) {
    const patterns = this.isShare ? this.sharePattern : this.hidePattern;
    if (patterns.length === index + 1) {
      patterns.push("");
    }
  }
  removePattern(num: number) {
    if (this.isShare && this.sharePattern) {
      this.sharePattern = this.sharePattern.filter(
        (pattern, index) => index !== num
      );
    } else if (this.hidePattern) {
      this.hidePattern = this.hidePattern.filter(
        (pattern, index) => index !== num
      );
    }
  }
  format(): string[] {
    const result = this.isShare ? this.sharePattern : this.hidePattern;
    return result.filter((item) => item !== "");
  }
}
export default PathPattern;
